import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";
import "./style.css";

const Index = ({ setActive }) => {
  const [form] = Form.useForm();
  const [secBuyer, setSecBuyer] = useState(false);
  const [thirdBuyer, setThirdBuyer] = useState(false);
  const [secSeller, setSecSeller] = useState(false);
  const [thirdSeller, setThirdSeller] = useState(false);
  const [showOtherInspection, setShowOtherInspection] = useState(false);
  const [requestRemedy, setRequestRemedy] = useState(false);
  const [requestCredit, setRequestCredit] = useState(false);
  const [electTerminate, setElectTerminate] = useState(false);
  const [selectedInspections, setSelectedInspections] = useState([]);

  const clearRemedyFields = () => {
    form.setFieldsValue({
      remedy_description: undefined,
      terminate_days: undefined,
    });
  };

  const clearCreditFields = () => {
    form.setFieldsValue({ credit_amount: undefined });
  };

  const toggleInspection = (value, checked) => {
    setSelectedInspections((prev) => {
      const next = checked
        ? [...prev, value]
        : prev.filter((item) => item !== value);
      setShowOtherInspection(next.includes("other"));
      if (!next.includes("other")) {
        form.setFieldsValue({ other_inspection: undefined });
      }
      return next;
    });
  };

  const selectBuyerOption = (option) => {
    if (option === "remedy") {
      const next = !requestRemedy;
      setRequestRemedy(next);
      setRequestCredit(false);
      setElectTerminate(false);
      clearCreditFields();
      if (!next) clearRemedyFields();
    } else if (option === "credit") {
      const next = !requestCredit;
      setRequestCredit(next);
      setRequestRemedy(false);
      setElectTerminate(false);
      clearRemedyFields();
      if (!next) clearCreditFields();
    } else if (option === "terminate") {
      const next = !electTerminate;
      setElectTerminate(next);
      setRequestRemedy(false);
      setRequestCredit(false);
      clearRemedyFields();
      clearCreditFields();
    }
  };

  const onSubmit = async (values) => {
    if (selectedInspections.length === 0) {
      message.error("Select at least one inspection!");
      return;
    }
    if (!requestRemedy && !requestCredit && !electTerminate) {
      message.error("Select at least one buyer option!");
      return;
    }
    setActive(true);
    values.unsatisfactory_inspections = selectedInspections;
    values.request_remedy = requestRemedy;
    values.request_credit = requestCredit;
    values.elect_terminate = electTerminate;
    if (values.contract_date) {
      values.contract_date = values.contract_date.format
        ? values.contract_date.format("YYYY-MM-DD")
        : values.contract_date;
    }
    if (Array.isArray(values.signed_contract)) {
      values.signed_contract = values.signed_contract[0];
    }
    console.log(values);
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/post-inspection`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Post Inspection";
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  return (
    <div className="main">
      <Form form={form} autoComplete="off" onFinish={onSubmit}>
        <label className="section-label">Signed Contract [check one]</label>
        <Form.Item
          name="signed_contract"
          rules={[{ required: true, message: "required!" }]}
        >
          <Checkbox.Group
            className="checkbox-row"
            onChange={(checkedValues) => {
              if (checkedValues.length > 1) {
                form.setFieldsValue({
                  signed_contract: [checkedValues[checkedValues.length - 1]],
                });
              }
            }}
          >
            <Checkbox value="contract_to_purchase">
              Contract to Purchase Real Estate
            </Checkbox>
            <Checkbox value="standard_residential">
              Standard Residential Purchase and Sales Agreement
            </Checkbox>
          </Checkbox.Group>
        </Form.Item>

        <label className="section-label">Contract Date</label>
        <Form.Item
          name="contract_date"
          rules={[{ required: true, message: "required!" }]}
        >
          <DatePicker />
        </Form.Item>

        <div className="fieldMain">
          <div className={`field ${secBuyer ? "" : "mtMinus"}`}>
            <div>
              <div className="plusHeader">
                {(!secBuyer || !thirdBuyer) && (
                  <div
                    className="plus"
                    onClick={() => {
                      if (!secBuyer) {
                        setSecBuyer(true);
                      } else {
                        setThirdBuyer(true);
                      }
                    }}
                  >
                    +
                  </div>
                )}
                <label className="form-title">Buyer(s)</label>
              </div>
              <Form.Item
                name="buyerName"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            {secBuyer && (
              <Form.Item
                name="buyerName2"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            )}
            {thirdBuyer && (
              <Form.Item
                name="buyerName3"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            )}
          </div>

          <div className={`field ${secSeller ? "" : "mtMinus"}`}>
            <div>
              <div className="plusHeader">
                {(!secSeller || !thirdSeller) && (
                  <div
                    className="plus"
                    onClick={() => {
                      if (!secSeller) {
                        setSecSeller(true);
                      } else {
                        setThirdSeller(true);
                      }
                    }}
                  >
                    +
                  </div>
                )}
                <label className="form-title">Seller(s)</label>
              </div>
              <Form.Item
                name="sellerName"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            {secSeller && (
              <Form.Item
                name="sellerName2"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            )}
            {thirdSeller && (
              <Form.Item
                name="sellerName3"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  className="input"
                  placeholder="Enter Full Name"
                  autoComplete="off"
                />
              </Form.Item>
            )}
          </div>
        </div>

        <label className="section-label">Property Address</label>
        <Form.Item
          name="property_address"
          rules={[{ required: true, message: "required!" }]}
        >
          <Input placeholder="Enter Property Address" autoComplete="off" />
        </Form.Item>

        <label className="section-label">
          In accordance with paragraph 7b of the Contract to Purchase or
          paragraph 17 of the Standard Residential Purchase and Sales Agreement
          Buyer hereby notifies Seller that the following inspection(s) is/are
          unsatisfactory [check one or more]
        </label>
        <div className="checkbox-grid">
          <Checkbox
            checked={selectedInspections.includes("home_inspection")}
            onChange={(e) =>
              toggleInspection("home_inspection", e.target.checked)
            }
          >
            Home Inspection
          </Checkbox>
          <Checkbox
            checked={selectedInspections.includes("radon_inspection")}
            onChange={(e) =>
              toggleInspection("radon_inspection", e.target.checked)
            }
          >
            Radon Inspection
          </Checkbox>
          <Checkbox
            checked={selectedInspections.includes("lead_inspection")}
            onChange={(e) =>
              toggleInspection("lead_inspection", e.target.checked)
            }
          >
            Lead Inspection
          </Checkbox>
          <Checkbox
            checked={selectedInspections.includes("pest_inspection")}
            onChange={(e) =>
              toggleInspection("pest_inspection", e.target.checked)
            }
          >
            Pest Inspection
          </Checkbox>
          <Checkbox
            checked={selectedInspections.includes("energy_usage_efficiency")}
            onChange={(e) =>
              toggleInspection("energy_usage_efficiency", e.target.checked)
            }
          >
            Energy Usage/Efficiency Inspection
          </Checkbox>
          <Checkbox
            checked={selectedInspections.includes("septic_sewer")}
            onChange={(e) =>
              toggleInspection("septic_sewer", e.target.checked)
            }
          >
            Septic/Sewer Inspection
          </Checkbox>
          <Checkbox
            checked={selectedInspections.includes("water_quality_drainage")}
            onChange={(e) =>
              toggleInspection("water_quality_drainage", e.target.checked)
            }
          >
            Water Quality/Drainage Inspection
          </Checkbox>
          <div className="other-inspection-inline">
            <Checkbox
              checked={selectedInspections.includes("other")}
              onChange={(e) => toggleInspection("other", e.target.checked)}
            >
              Other
            </Checkbox>
            {showOtherInspection && (
              <Form.Item
                name="other_inspection"
                rules={[{ required: true, message: "required!" }]}
                noStyle
              >
                <Input
                  className="other-inspection-input"
                  placeholder="Describe other inspection"
                  autoComplete="off"
                />
              </Form.Item>
            )}
          </div>
        </div>

        <label className="section-label terminate-heading">
          PARAGRAPH 7b OF THE CONTRACT TO PURCHASE AND PARAGRAPH 17 OF THE
          STANDARD RESIDENTIAL PURCHASE AND SALES AGREEMENT ALLOWS BUYER TO
          TERMINATE THE CONTRACT BASED UPON THE CONDITIONS THAT ARE
          UNSATISFACTORY TO BUYER IN BUYER&apos;S SOLE DISCRETION
        </label>
        <label className="section-label">Check appropriate box:</label>

        <div className="option-block">
          <Checkbox
            checked={requestRemedy}
            onChange={() => selectBuyerOption("remedy")}
          >
            Buyer requests that Seller remedy the following unsatisfactory
            condition(s) at Seller&apos;s expense prior to closing [describe
            work or see attached documentation]:
          </Checkbox>
          {requestRemedy && (
            <>
              <Form.Item
                name="remedy_description"
                rules={[{ required: true, message: "required!" }]}
                style={{ marginTop: "0.75rem" }}
              >
                <TextArea
                  rows={4}
                  style={{ resize: "none", height: "auto" }}
                  placeholder="Describe unsatisfactory condition(s)"
                />
              </Form.Item>
              <div className="inline-days">
                <span>
                   Buyer may terminate the contract
                  with written notice within{" "}
                </span>
                <Form.Item
                  name="terminate_days"
                  rules={[{ required: true, message: "required!" }]}
                >
                  <Input
                    style={{ width: "5rem" }}
                    placeholder="days"
                    autoComplete="off"
                  />
                </Form.Item>
                <span className="inline-days-after">
                  days of this Notice if Buyer and Seller cannot come to a
                  mutually satisfactory agreement concerning these conditions.
                </span>
              </div>
            </>
          )}
        </div>

        <div className="option-block">
          <div className="inline-amount">
            <Checkbox
              checked={requestCredit}
              onChange={() => selectBuyerOption("credit")}
            >
              Buyer hereby requests that Seller provide a credit in the amount
              of $
            </Checkbox>
            {requestCredit && (
              <Form.Item
                name="credit_amount"
                rules={[{ required: true, message: "required!" }]}
              >
                <Input
                  style={{ width: "10rem" }}
                  placeholder="Amount"
                  autoComplete="off"
                />
              </Form.Item>
            )}
          </div>
        </div>

        <div className="option-block">
          <Checkbox
            checked={electTerminate}
            onChange={() => selectBuyerOption("terminate")}
          >
            Buyer hereby elects to terminate the Contract based upon the
            unsatisfactory condition(s)
          </Checkbox>
        </div>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
